import Layout from '@/layout';
var artCardRouter = {
  path: '/art-card',
  component: Layout,
  redirect: '/art-card/templates',
  name: 'ArtCard',
  alwaysShow: true,
  meta: {
    title: '艺卡管理',
    icon: 'postcard'
  },
  children: [{
    path: 'templates',
    component: function component() {
      return import('@/views/artCard/templates');
    },
    name: 'ArtCardTemplates',
    meta: {
      title: '模板管理'
    }
  }]
};
export default artCardRouter;